import router from '@/router';
import store from '@/store/store';

export function errorHandlerCredenciamento(error) {
    if (error.response) {
        if (error.response.status === 401 || error.response.status === 403) {
            store.dispatch('tryAutoLogin');
            if (store.getters.estaAutenticado) {
                router.push('/naoautorizado');
            } else {
                router.push('/login');
            }
        } else if (error.response.status === 400 || error.response.status === 404) {
            let errorData = error.response.data;
            if (error.response.config.responseType == 'blob') {
                return ['Erro ao obter arquivo ou arquivo inexistente.'];
            } else if (errorData.exception) {
                return [`Erro: ${errorData.message}`];
            } else {
                return [...errorData.errors.mensagens];
            }
        } else {
            const data = error.response?.data;

            if (typeof data === 'object' && data !== null) {
                if (data.message) {
                    return [data.message];
                } else if (data.title) {
                    if (data.title === 'An error occurred while processing your request.') {
                        return ['Ocorreu um erro inesperado.'];
                    }
                    return [data.title];
                }
            }

            if (typeof data === 'string') {
                return [data];
            }

            return ['Ocorreu um erro inesperado.'];
        }
    } else if (error.request) {
        return ['Erro na requisição.'];
    }
}
